import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { marginAttributes, propsBlocker } from '../../system';
export var SVGIconRoot = styled.svg.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    user-select: none;\n    line-height: inherit;\n    ", "\n    ", "\n"])), function (_ref) {
  var iconWidth = _ref.iconWidth,
      iconHeight = _ref.iconHeight,
      fontSize = _ref.fontSize,
      theme = _ref.theme,
      display = _ref.display;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        display: ", ";\n        width: ", ";\n        height: ", ";\n        font-size: ", ";\n    "])), display, iconWidth, iconHeight, typeof fontSize !== 'undefined' ? theme.typography.pixelToRem(fontSize) : 'inherit');
}, marginAttributes);